var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts"},[_c('div',{ref:"chart1",attrs:{"id":"chart1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }